import React, { useRef } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import SimparyChat from "../wizard/SimparyChat";
import styles from "../../styles/components/product/ProductAskChat.module.css";

const DEFAULT_PROMPTS = [
  "Is the top match worth the extra cost?",
  "Which is better for my use case?",
  "What am I giving up with the cheaper option?",
];

const ComparisonAskChat = ({
  products = [],
  aiSession = null,
  searchParams = null,
  comparisonTable = null,
  expanded = false,
  onExpandedChange,
  prefillPrompt = null,
  onPrefillConsumed,
  suggestedPrompts = DEFAULT_PROMPTS,
  onSuggestedPrompt,
}) => {
  const chatRef = useRef(null);

  const compareContext = {
    products: products.map((product) => ({
      _id: product._id || product.id,
      name: product.name,
      price: product.price,
      matchScore: product.matchScore ?? product.score ?? null,
      rank: product.rank ?? null,
      specifications: product.specifications || [],
    })),
    searchParams,
    comparisonTable,
  };

  const handleSuggestedClick = (prompt) => {
    onExpandedChange?.(true);
    onSuggestedPrompt?.(prompt);
  };

  if (!products || products.length < 2) return null;

  return (
    <div className={styles.wrapper}>
      {expanded ? (
        <div className={styles.chatCard}>
          <button
            type="button"
            className={styles.collapseBtn}
            onClick={() => onExpandedChange?.(false)}
            aria-label="Collapse chat"
            aria-expanded={true}
          >
            <FaChevronUp aria-hidden />
          </button>
          <div className={styles.promptChips}>
            {suggestedPrompts.map((prompt) => (
              <button
                key={prompt}
                type="button"
                className={styles.promptChip}
                onClick={() => handleSuggestedClick(prompt)}
              >
                {prompt}
              </button>
            ))}
          </div>
          <SimparyChat
            ref={chatRef}
            embedded
            panel
            mode="compare"
            compareContext={compareContext}
            aiSession={aiSession}
            prefillPrompt={prefillPrompt}
            onPrefillConsumed={onPrefillConsumed}
            hideIdentityBanner
          />
        </div>
      ) : (
        <button
          type="button"
          className={styles.collapsedBar}
          onClick={() => onExpandedChange?.(true)}
          aria-expanded={false}
        >
          <span className={styles.collapsedTitle}>
            Ask Simpary to help you choose
          </span>
          <span className={styles.collapsedHint}>
            Trade-offs, fit for your needs, or which pick to make
          </span>
          <FaChevronDown className={styles.collapsedIcon} aria-hidden />
        </button>
      )}
    </div>
  );
};

export default ComparisonAskChat;
